import axios from 'axios'
import axiosInstance from '@/plugins/axios'
function uuid() {
  const s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  const uuid = s.join('')
  return uuid
}
function getDay() {
  const date = new Date()
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  month = month > 9 ? month : '0' + month
  day = day < 10 ? '0' + day : day
  return year + '-' + month + '-' + day
}
function getFileName(file) {
  return getDay() + '/' + uuid() + '.' + file.name.split('.').pop()
}
function webUpload(file) {
  return new Promise((resolve) => {
    const fileName = getFileName(file)
    axiosInstance
      .post('/additional/admin/file/upload/token', {
        method: 'PUT',
        type: 'default',
        key: fileName,
        contentType: file.type || '',
      })
      .then((res) => {
        console.log(res)
        if (res.success) {
          axios({
            method: 'put',
            url: res.data.host + '/' + res.data.key,
            file,
            headers: {
              'Content-Type': res.data.contentType,
              Authorization: res.data.token,
            },
            data: file,
          }).then((eee) => {
            if (eee.status === 200) {
              resolve({ data: res.data.url })
            }
          })
        }
      })
  })
}
export { webUpload }
